import { useQuery } from '@tanstack/react-query';
import { supabase } from '@/lib/supabase/client';

/** Question images live in a private bucket; resolve a short-lived signed URL. */
export function useSignedImage(path: string | null | undefined): string | null {
  const isAbsolute = !!path && /^https?:\/\//.test(path);
  const { data } = useQuery({
    queryKey: ['signed-image', path],
    enabled: !!path && !isAbsolute,
    staleTime: 50 * 60 * 1000,
    queryFn: async () => {
      const { data, error } = await supabase.storage.from('question-media').createSignedUrl(path!, 60 * 60);
      if (error) throw error;
      return data.signedUrl;
    },
  });
  if (!path) return null;
  return isAbsolute ? path : (data ?? null);
}
